import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "eq_cookie_consent_v1";
const GTM_ID = "GTM-54CFN3TV";

type Consent = "accepted" | "rejected" | null;

const loadGTM = () => {
  if (document.getElementById("gtm-script")) return;
  const s = document.createElement("script");
  s.id = "gtm-script";
  s.async = true;
  s.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`;
  document.head.appendChild(s);
};

const CookieConsent = () => {
  const [consent, setConsent] = useState<Consent>(null);
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY) as Consent;
    setConsent(stored);
    setHydrated(true);
    if (stored === "accepted") loadGTM();
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setConsent("accepted");
    loadGTM();
  };
  const reject = () => {
    localStorage.setItem(STORAGE_KEY, "rejected");
    setConsent("rejected");
  };

  if (!hydrated || consent !== null) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] p-3 sm:p-4 pointer-events-none">
      <div className="pointer-events-auto max-w-3xl mx-auto bg-card/95 backdrop-blur-xl border border-border rounded-2xl shadow-2xl p-4 sm:p-5">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
            <Cookie className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-foreground text-sm sm:text-base mb-1">
              Sua privacidade é importante
            </h3>
            <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
              Usamos cookies e ferramentas de análise apenas com seu consentimento para melhorar sua experiência.
              Por tratarmos dados sensíveis de saúde (Art. 11 da LGPD), seus dados nunca são compartilhados sem base legal.{" "}
              <Link to="/politica-de-privacidade" className="text-primary underline hover:no-underline">
                Saiba mais
              </Link>
              .
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <Button size="sm" variant="hero" onClick={accept}>
                Aceitar todos
              </Button>
              <Button size="sm" variant="outline" onClick={reject}>
                Rejeitar opcionais
              </Button>
            </div>
          </div>
          <button
            onClick={reject}
            aria-label="Fechar"
            className="text-muted-foreground hover:text-foreground transition-colors shrink-0"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;